/**
 * @mhmo91/ican — boolean combinators.
 *
 * Top-level imports the rule callback uses to compose `Cond` nodes:
 *
 *     when((data, me) => and(
 *       data.orgId.eq(me.orgId),
 *       data.status.eq('draft'),
 *       not(data.total.gte(5000)),
 *     )).allow('edit')
 *
 * `and` and `or` accept a variadic spread; `not` takes a single child.
 * Each builds a single AST node — the runtime evaluator and the
 * Firestore emitter pattern-match on `kind`.
 */
import type { Cond } from './types.ts';

export const and = (...nodes: readonly Cond[]): Cond => ({ kind: 'and', nodes });

export const or = (...nodes: readonly Cond[]): Cond => ({ kind: 'or', nodes });

export const not = (node: Cond): Cond => ({ kind: 'not', node });
